module.exports = __webpack_public_path__ + "static/media/0323_IMG_TRAD_LES_ENSEIGNES_LE_FROMAGER_LETTRE_A_LETTRE.a0567ad2.webp";